import React, { useState } from "react";
import Preloader from "../../helper/Preloader";
import ColorInit from "../../helper/ColorInit";
import Breadcrumb from "../../components/Breadcrumb";
import BottomFooter from "../../components/BottomFooter";
import ShippingOne from "../../components/ShippingOne";
import Checkout from "../../components/Checkout";
import ScrollToTop from "react-scroll-to-top";
import HeaderOne from "../../components/HeaderOne";
import FooterOne from "../../components/FooterOne";

const CheckoutPage = () => {

const [selectedCurrency, setSelectedCurrency] = useState(
    localStorage.getItem("selectedCurrency")
  );

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      {/* <ScrollToTop smooth color="#1E293B" /> */}

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOne category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Checkout"} />

      {/* Checkout */}
      <Checkout selectedCurrency={selectedCurrency} />

      {/* ShippingOne */}
      <ShippingOne />

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      {/* <BottomFooter /> */}


    </>
  );
};

export default CheckoutPage;
